export enum TailwindColor {
  Black = '#000000',
  Blue50 = '#eff6ff',
  Blue100 = '#dbeafe',
  Blue200 = '#bfdbfe',
  Blue300 = '#93c5fd',
  Blue400 = '#60a5fa',
  Blue500 = '#3b82f6',
  Blue600 = '#2563eb',
  Blue700 = '#1d4ed8',
  Blue800 = '#1e40af',
  Blue900 = '#1e3a8a',
  Blue950 = '#172554',
  Cyan600 = '#0891b2',
  GovWellBlue = '#0A2E57', // Original GovWell blue: rgb(10, 46, 87)
  Gray700 = '#374151',
  Gray500 = '#6b7280',
  Gray400 = '#9ca3af',
  Emerald500 = '#10b981',
  Green200 = '#bbf7d0',
  Green600 = '#16a34a',
  Green700 = '#15803d',
  Green900 = '#14532d',
  Neutral950 = '#0a0a0a',
  Neutral200 = '#e5e5e5',
  Neutral50 = '#fafafa',
  Purple600 = '#9333ea',
  Red200 = '#fecaca',
  Red600 = '#dc2626',
  Red700 = '#b91c1c',
  Red800 = '#991b1b',
  Red900 = '#7f1d1d',
  Sky50 = '#f0f9ff',
  Sky100 = '#e0f2fe',
  Sky200 = '#bae6fd',
  Sky300 = '#7dd3fc',
  Sky400 = '#38bdf8',
  Sky500 = '#0ea5e9',
  Sky600 = '#0284c7',
  Sky700 = '#0369a1',
  Sky800 = '#075985',
  Sky900 = '#0c4a6e',
  Sky950 = '#082f49',
  Orange400 = '#fb923c',
  Orange500 = '#f97316',
  Orange600 = '#ea580c',
  Pink600 = '#db2777',
  Purple500 = '#a855f7',
  White = '#ffffff',
  Yellow500 = '#eab308',
  Yellow600 = '#ca8a04',
}
